// 行业招聘信息
export default [
	{
        //首页
		path: '/recruitIndex',
		name: 'recruitIndex',
		component: () => import('@/views/recruit/recruitIndex')
    },
    {
        //详情
		path: '/recruitDetail',
		name: 'recruitDetail',
		component: () => import('@/views/recruit/recruitDetail')
	}
]


// WEBPACK FOOTER //
// ./src/router/modules/recuit.js